var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9168 1.40997C10.5192 1.59518 10.0157 1.76902 9.56454 1.82681C10.0234 1.54071 10.7514 0.944814 10.9168 0.405762C10.4881 0.670551 9.71284 0.95334 9.20709 1.05566C8.80321 0.605656 8.22714 0.405762 7.58887 0.405762C6.36281 0.405762 5.50772 1.4976 5.50772 2.77418V3.72155C3.70469 3.72155 1.94674 2.27824 0.85275 0.879446C0.654939 1.232 0.551087 1.63401 0.552095 2.04329C0.552095 2.90492 1.30531 3.77934 1.90166 4.19523C1.5379 4.18339 0.849144 3.8916 0.54939 3.72155V3.74855C0.54939 4.86976 1.2981 5.63097 2.31275 5.84318C2.12749 5.89671 1.90166 6.08997 1.0326 6.08997C1.31478 7.00655 2.73331 7.49113 3.70469 7.51102C2.94472 8.13013 1.58974 8.45839 0.54939 8.45839C0.369538 8.45839 0.272174 8.46881 0.0986328 8.4475C1.08038 9.10118 2.45159 9.40576 3.70469 9.40576C7.7872 9.40576 10.0153 6.12881 10.0153 3.0726C10.0153 2.97218 10.0121 2.63587 10.0072 2.53734C10.4435 2.21429 10.6202 1.87608 10.9168 1.40997Z",
    fill: "#FFFEFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon-1.f088b6ea57c86818a91b965acfe41878.svg";
export { ForwardRef as ReactComponent };